module.exports = __webpack_public_path__ + "062aec623296d9a2b8177a01a9143654.svg";